import Footer from 'components/Footer';

import { StyledColumn } from '../LookerDashboardSideBar.styles';
import { LookerDashboard } from './LookerDashboard';

export const DashboardLegacy = () => {
  return (
    <StyledColumn>
      <LookerDashboard dashId={0} />
      <Footer />
    </StyledColumn>
  );
};
